var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flix-text-center"},[_c('b',[_vm._v(_vm._s(_vm.data.booking_id))]),_c('qrCode',{attrs:{"url":_vm.url,"link":''}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }